import "esbuild-css-modules-plugin-ns-css:src/js/pages/quizController/quizController.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/quizController/quizController.module.css:injector.js";
export default new Proxy({
  "arrowIcon": "quizController-module__arrowIcon_TIFCrG__1100",
  "associatedModalBackground": "quizController-module__associatedModalBackground_TIFCrG__1100",
  "associatedModalButtonContainer": "quizController-module__associatedModalButtonContainer_TIFCrG__1100",
  "associatedModalContainer": "quizController-module__associatedModalContainer_TIFCrG__1100",
  "associatedModalText": "quizController-module__associatedModalText_TIFCrG__1100",
  "associatedModalTitle": "quizController-module__associatedModalTitle_TIFCrG__1100",
  "formContainer": "quizController-module__formContainer_TIFCrG__1100",
  "formContainerResultsStep": "quizController-module__formContainerResultsStep_TIFCrG__1100",
  "groupRight": "quizController-module__groupRight_TIFCrG__1100",
  "navigationBar": "quizController-module__navigationBar_TIFCrG__1100",
  "prevIcon": "quizController-module__prevIcon_TIFCrG__1100",
  "restartIcon": "quizController-module__restartIcon_TIFCrG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      